/** @format */

const API_KEY_DEFAULT = "7a5bbc58-7137-4c97-a43a-04701b658418";

let API_KEY_ENV;
if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_API_KEY) {
  API_KEY_ENV = import.meta.env.VITE_API_KEY;
} else if (process.env && process.env.VUE_APP_API_KEY) {
  API_KEY_ENV = process.env.VUE_APP_API_KEY;
} else {
  API_KEY_ENV = API_KEY_DEFAULT;
}
const API_KEY = API_KEY_ENV;

const getAuthHeader = () => ({
  Authorization: localStorage.getItem("sesion"),
  ApiKey: API_KEY,
});

export default {
  header() {
    return {
      headers: {
        ...getAuthHeader(),
      },
    };
  },

  headerMultipart(onUploadProgress) {
    const config = {
      headers: {
        ...getAuthHeader(),
        "Content-Type": "multipart/form-data",
      },
    };

    if (onUploadProgress) {
      config.onUploadProgress = onUploadProgress;
    }
    return config;
  },
};
